<template lang="html">
  <div class="detail" style="position: relative">
    <div class="content hidden-appdeatils">
      <div class="contentBox">
        <div class="top-banner">
          <div class="breadCrum">
            <el-breadcrumb separator-class="el-icon-arrow-right">
              <el-breadcrumb-item class="toProducts">
                <span @click="toProducts">
                  {{
                    $t("detail.top")
                  }}
                </span>
              </el-breadcrumb-item>
              <el-breadcrumb-item>
                {{
                  this.productData.productName
                }}
              </el-breadcrumb-item>
            </el-breadcrumb>
          </div>
        </div>
        <!-- top-banner结束 -->
        <div class="main">
          <div class="left-banner">
            <div class="productImage">
              <img :src="productData.largeIcon" alt="" />
            </div>
            <div class="marketPricing" v-if="productData.marketPricingCN">￥{{ price }}</div>
            <div class="marketPricing" v-if="productData.marketPricingCN === 0">Free</div>
            <div class="btn" @click="deploy" v-if="productData.type == 1">
              {{ $t("brick.btn") }}
            </div>
            <div class="btn" @click="contact(productData.id, productData.productName)"
              v-else-if="productData.type == 2">
              {{ $t("brick.btn2") }}
            </div>
            <div class="btn" @click="contact(productData.id, productData.productName)"
              v-else-if="productData.type == 3">
              {{ $t("brick.btn2") }}
            </div>
            <el-dialog :visible.sync="dialogTableVisible" center :append-to-body="true">
              <Login></Login>
            </el-dialog>
            <el-dialog :visible.sync="dialogTableVisibleinfo" center :append-to-body="true">
              <Info :product="productData"></Info>
            </el-dialog>
            <div class="collect" @click="toggle(productData.productIdentity, productData.collectStatus)" v-if="isLogin">
              <i class="iconfont icon-uncollected" v-show="!productData.collectStatus"></i>
              <i class="iconfont icon-collect" v-show="productData.collectStatus"></i>
              <span v-show="!productData.collectStatus">{{
                $t("detail.uncollected")
              }}</span>
              <span v-show="productData.collectStatus">{{
                $t("detail.collect")
              }}</span>
            </div>
            <div class="info">
              <div class="list_detail" v-if="productData.price">
                <p style="font-size: 14px; font-weight: 600">
                  {{ $t("detail.priceInfo") }}
                </p>
                <div class="min-text">
                  <p class="min-text line-height-20 blue-text" v-if="productData.priceType === 4"
                    @click="handleClick(1)">
                    {{ $t('detail.priceVaries') }}
                  </p>
                  <p class="min-text line-height-20 blue-text" @click="handleClick(1)" v-else>
                    {{ productData.price }}
                  </p>
                  <p class="line-height-20">{{ $t("detail.cost") }}</p>
                </div>
              </div>
              <div v-if="productData.categoryList &&
                productData.categoryList.length > 0
              " class="list_detail">
                <p>{{ $t("detail.text0") }}</p>
                <ul v-for="item in productData.categoryList">
                  <li @click="toProductList(item)" class="category">
                    {{ item.categoryName }}
                  </li>
                </ul>
              </div>
              <div v-if="productData.supportUri" class="list_detail">
                <p>{{ $t("detail.text6") }}</p>
                <p>
                  <a :href="productData.supportUri" target="_blank">{{ $t("detail.text6") }}</a>
                </p>
              </div>
              <div v-if="productData.legal && productData.legal.legalTermsUri && productData.legal.privacyPolicyUri"
                class="list_detail">
                <p>{{ $t("detail.text1") }}</p>
                <p>
                  <a :href="productData.legal.legalTermsUri" target="_blank">{{
                    $t("detail.text2")
                  }}</a>
                </p>
                <p>
                  <a :href="productData.legal.privacyPolicyUri" target="_blank">{{ $t("detail.text3") }}</a>
                </p>
              </div>
              <div v-if="this.productData.serviceProvider
              " class="list_detail">
                <p>{{ $t("detail.text4") }}</p>
                <p>{{ this.productData.serviceProvider }}</p>
              </div>
              <div v-if="this.productData.serviceContact && this.productData.type == 2
              " class="list_detail">
                <p>{{ $t("detail.text5") }}</p>
                <p>{{ this.productData.serviceContact }}</p>
              </div>
              <div v-if="this.productData.serviceEmail
              " class="list_detail">
                <p>{{ $t("detail.text7") }}</p>
                <p>{{ this.productData.serviceEmail }}</p>
              </div>
              <div v-if="this.productData.provider &&
                this.productData.provider.telephone
              " class="provider">
                <p>{{ $t("detail.text4_1") }}</p>
                <p>
                  <a :href="'tel:' + this.productData.provider.telephone" target="_blank">
                    {{ this.productData.provider.telephone }}</a>
                </p>
              </div>
              <div v-if="this.productData.provider && this.productData.provider.email
              " class="provider">
                <p>{{ $t("detail.text4_2") }}</p>
                <p>
                  <a :href="'mailto:' + this.productData.provider.email">{{
                    this.productData.provider.email
                  }}</a>
                </p>
              </div>
              <div v-if="this.productData.provider && this.productData.provider.wheChat
              " class="provider">
                <p>{{ $t("detail.text4_3") }}</p>
                <p>{{ this.productData.provider.wheChat }}</p>
              </div>
              <div v-if="this.productData.provider && this.productData.provider.qq" class="provider">
                <p>{{ $t("detail.text4_4") }}</p>
                <p>{{ this.productData.provider.qq }}</p>
              </div>
              <div v-if="this.productData.provider && this.productData.provider.weibo
              " class="provider">
                <p>{{ $t("detail.text4_5") }}</p>
                <p>{{ this.productData.provider.weibo }}</p>
              </div>
            </div>
            <!-- info结束 -->
          </div>
          <!-- left结束 -->
          <div class="right-banner">
            <div class="title">
              <p>{{ productData.productName }}</p>
              <p class="publishname">
                {{ productData.publisherDisplayName }}
              </p>
            </div>
            <div class="navBar" v-if="productData.type === 1">
              <div v-if="langIsCn">
                <nav-Menu :list="list_cn2" :idxId="idx" @handleClick="handleClick"></nav-Menu>
              </div>
              <div v-else>
                <nav-Menu :list="list_en2" :idxId="idx" @handleClick="handleClick"></nav-Menu>
              </div>
            </div>
            <div class="contentText">
              <div v-if="idx == 0" class="detaildesc">
                <div v-if="productData.screenShotList &&
                  productData.screenShotList.length > 0
                ">
                  <el-row>
                    <el-col :xs="24" :sm="24" :md="24" :lg="13" :xl="13">
                      <div class="description">
                        <div class="offerSummary" v-html="productData.offerSummary"></div>
                        <div class="paragraph" v-html="productData.offerDescription"></div>
                        <div style="margin-top: 20px" v-if="productData.learnMoreLinks &&
                          productData.learnMoreLinks.length > 0
                        ">
                          <p>{{ $t("detail.more") }}</p>
                          <ul>
                            <li v-for="(item, key) in productData.learnMoreLinks">
                              <a :href="[item.uri]" target="_blank">{{
                                item.displayName
                              }}</a>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </el-col>
                    <el-col :xs="24" :sm="24" :md="24" :lg="11" :xl="11">
                      <div class="imgswiper hidden-sm-and-down">
                        <div class="wideImg" @click="imgPreview" v-if="wideType == 2">
                          <img :src="productData.screenShotList[imgUrlidx].url" />
                        </div>
                        <div class="wideImg" @click="imgPreview" v-else-if="wideType == 1">
                          <img src="@/assets/image/video.png" />
                        </div>
                        <div class="smallImg">
                          <div class="imglist" v-for="(img, index) in productData.screenShotList" :key="index">
                            <img :src="img.url" v-if="img.type == 2" @click="showWideImg(img.type, index)" />
                            <img src="@/assets/image/video.png" v-else-if="img.type == 1"
                              @click="showWideImg(img.type, index)" />
                          </div>
                        </div>
                      </div>
                    </el-col>
                  </el-row>
                  <div class="imgswiper-sm hidden-sm-and-up">
                    <div class="wideImg" @click="imgPreview" v-if="wideType == 2">
                      <img :src="productData.screenShotList[imgUrlidx].url" />
                    </div>
                    <div class="wideImg" @click="imgPreview" v-else-if="wideType == 1">
                      <img src="@/assets/image/video.png" />
                    </div>
                    <div class="smallImg">
                      <div class="imglist" v-for="(img, index) in productData.screenShotList" :key="index"
                        @click="showWideImg(img.type, index)">
                        <img :src="img.url" />
                      </div>
                    </div>
                  </div>
                  <!-- 点击图片遮罩 -->
                  <div v-show="show" class="cover hidden-sm-and-down">
                    <div class="previewImg">
                      <img v-if="wideType == 2" :src="productData.screenShotList[imgUrlidx].url" class="imgItem" />
                      <iframe v-if="wideType == 1" width="500" height="360" frameborder="0" scrolling="auto"
                        :src="productData.screenShotList[imgUrlidx].videoLink"></iframe>
                      <div class="close" @click="close">
                        <i class="iconfont icon-quxiao"></i>
                      </div>
                    </div>
                  </div>
                  <div v-show="show" class="cover-sm hidden-sm-and-up">
                    <div class="previewImg">
                      <img v-if="wideType == 2" :src="productData.screenShotList[imgUrlidx].url" class="imgItem" />
                      <iframe width="500" height="360" frameborder="0" scrolling="auto" v-if="wideType == 1"
                        :src="productData.screenShotList[imgUrlidx].videoLink"></iframe>
                      <div class="close" @click="close">
                        <i class="iconfont icon-quxiao"></i>
                      </div>
                    </div>
                  </div>
                </div>
                <!-- 有图片的概述结束 -->
                <div v-else>
                  <div class="description">
                    <!-- <p class="offerSummary">{{ productData.offerSummary }}</p> -->
                    <div class="offerSummary" v-html="productData.offerSummary"></div>
                    <div class="paragraph" v-html="productData.offerDescription"></div>
                    <div style="margin-top: 20px" v-if="productData.learnMoreLinks &&
                      productData.learnMoreLinks.length > 0
                    ">
                      <p>{{ $t("detail.more") }}</p>
                      <ul>
                        <li v-for="(item, key) in productData.learnMoreLinks">
                          <a :href="[item.uri]" target="_blank">{{
                            item.displayName
                          }}</a>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
                <!-- v-else结束 -->
              </div>
              <!-- v-if=0结束 -->
              <div v-else-if="idx == 1" class="detaildesc">
                <div v-if="productData.type === 1" class="plans">
                  <div class="description">
                    <div class="offerSummary" v-html="productData.planSummary"></div>
                    <div class="paragraph" v-html="productData.planDescription"></div>
                  </div>
                </div>
                <!-- plans结束 -->
                <div v-else class="pricing">
                  <div class="explain">
                    <p>{{ $t("detail.price_1") }}</p>
                    <p>
                      <span>{{ $t("detail.price_2") }}</span>
                      <router-link :to="{ name: 'Region', params: {} }" class="area">
                        <span>{{ $t("detail.price_3") }}</span>
                      </router-link>
                      <span>{{ $t("detail.price_4") }}</span>
                    </p>
                  </div>
                  <!-- explain结束 -->
                  <div class="planList" v-if="productData.planAndPrices &&
                    productData.planAndPrices.length <= 1
                  "></div>
                  <!-- v-if结束-->
                  <div v-else class="planList">
                    <p class="middle-text line-height-30" style="margin-bottom: 10px">
                      {{ $t("detail.planInfo1") }}
                    </p>
                  </div>
                  <!-- v-else结束-->
                  <!-- radio2table结束 -->
                </div>
                <!-- pricing结束 -->
              </div>
              <!-- v-if=1结束 -->
            </div>
            <!-- contentText结束 -->
          </div>
          <!-- right结束 -->
        </div>
        <!-- main结束 -->
      </div>
      <!-- contentBox结束 -->
    </div>
    <!-- content结束 -->
    <div class="content-mobile hidden-mobileappdeatils">
      <div class="toptitle">
        <div class="appimage">
          <img :src="productData.largeIcon" alt="" />
        </div>
        <div class="title">
          <p>{{ productData.productName }}</p>
          <p class="publishname">{{ this.productData.publisherDisplayName }}</p>
        </div>
      </div>
      <!-- toptitle结束 -->
      <div class="introduction">
        <p class="offerSummary">{{ productData.offerSummary }}</p>
        <div class="btn" @click="deploy" v-if="productData.type === 1">
          {{ $t("brick.btn") }}
        </div>
        <div class="btn" @click="contact(productData.id, productData.publisherDisplayName)"
          v-else-if="productData.type == 2">
          {{ $t("brick.btn2") }}
        </div>
        <div class="btn" @click="contact(productData.id, productData.publisherDisplayName)"
          v-else-if="productData.type == 3">
          {{ $t("brick.btn2") }}
        </div>
        <div class="collect" @click="toggle(productData.productIdentity, productData.collectStatus)" v-if="isLogin">
          <i class="iconfont icon-uncollected" v-show="!productData.collectStatus"></i>
          <i class="iconfont icon-collect" v-show="productData.collectStatus"></i>
          <span v-show="!productData.collectStatus">{{
            $t("detail.uncollected")
          }}</span>
          <span v-show="productData.collectStatus">{{
            $t("detail.collect")
          }}</span>
        </div>
      </div>
      <!-- introduction结束 -->
      <div class="description">
        <div class="info">
          <div :class="[infoDesc ? 'active' : 'info-title']" @click="showDesc">
            <p>{{ $t("detail.desc") }}</p>
            <i class="iconfont icon-xiala" v-if="!infoDesc"></i>
            <i class="iconfont icon-xiangshang" v-if="infoDesc"></i>
          </div>
          <div class="showinfo" v-show="this.infoDesc">
            <div class="paragraph" v-html="productData.offerDescription"></div>
          </div>
        </div>
        <!-- infodescription结束 -->
        <div class="info">
          <div :class="[infoMore ? 'active' : 'info-title']" @click="showMore">
            <p>{{ $t("detail.more") }}</p>
            <i class="iconfont icon-xiala" v-if="!infoMore"></i>
            <i class="iconfont icon-xiangshang" v-if="infoMore"></i>
          </div>
          <div class="showinfo" v-show="this.infoMore">
            <ul>
              <li v-for="(item, key) in productData.learnMoreLinks">
                <a :href="[item.uri]" target="_blank">{{ item.displayName }}</a>
              </li>
            </ul>
          </div>
        </div>
        <!-- infomore结束 -->
        <div class="screenshot" v-if="productData.screenShotList && productData.screenShotList.length > 0
        ">
          <div class="wideImg" @click="imgPreview">
            <img :src="productData.screenShotList[imgUrlidx]" />
          </div>
          <div class="smallImg">
            <div class="imglist" v-for="(img, index) in productData.screenShotList" :key="index"
              @click="showWideImg(index)">
              <img :src="img.url" />
            </div>
          </div>
        </div>
        <!-- 图片展示结束 -->
      </div>
      <!-- description结束 -->
      <div class="listinfo">
        <div v-if="productData.supportUri" class="list_detail">
          <p>{{ $t("detail.text6") }}</p>
          <p>
            <a :href="productData.supportUri" target="_blank">{{ $t("detail.text6") }}</a>
          </p>
        </div>
        <div v-if="productData.legal && productData.legal.legalTermsUri && productData.legal.privacyPolicyUri"
          class="list_detail">
          <p>{{ $t("detail.text1") }}</p>
          <p>
            <a :href="productData.legal.legalTermsUri" target="_blank">{{
              $t("detail.text2")
            }}</a>
          </p>
          <p>
            <a :href="productData.legal.privacyPolicyUri" target="_blank">{{
              $t("detail.text3")
            }}</a>
          </p>
        </div>
        <div v-if="this.productData.serviceProvider" class="list_detail">
          <p>{{ $t("detail.text4") }}</p>
          <p>{{ this.productData.serviceProvider }}</p>
        </div>
        <div v-if="this.productData.serviceContact && this.productData.type == 2" class="list_detail">
          <p>{{ $t("detail.text5") }}</p>
          <p>{{ this.productData.serviceContact }}</p>
        </div>
        <div v-if="this.productData.provider && this.productData.provider.telephone
        " class="provider">
          <p>{{ $t("detail.text4_1") }}</p>
          <p>
            <a :href="'tel:' + this.productData.provider.telephone" target="_blank">
              {{ this.productData.provider.telephone }}
            </a>
          </p>
        </div>
        <div v-if="this.productData.provider && this.productData.provider.email" class="provider">
          <p>{{ $t("detail.text4_2") }}</p>
          <p>
            <a :href="'mailto:' + this.productData.provider.email">{{
              this.productData.provider.email
            }}</a>
          </p>
        </div>
        <div v-if="this.productData.provider && this.productData.provider.wheChat" class="provider">
          <p>{{ $t("detail.text4_3") }}</p>
          <p>{{ this.productData.provider.wheChat }}</p>
        </div>
        <div v-if="this.productData.provider && this.productData.provider.qq" class="provider">
          <p>{{ $t("detail.text4_4") }}</p>
          <p>{{ this.productData.provider.qq }}</p>
        </div>
        <div v-if="this.productData.provider && this.productData.provider.weibo" class="provider">
          <p>{{ $t("detail.text4_5") }}</p>
          <p>{{ this.productData.provider.weibo }}</p>
        </div>
      </div>
      <!-- listinfo结束 -->
    </div>
    <!-- content-mobile结束 -->
  </div>
  <!-- detail结束 -->
</template>

<script>
import menu from "@/components/NavMenu";
import Login from "@/components/Login";
import Info from "@/components/Info";
import { toThousandths } from "@/utils/tools"
export default {
  name: "Detail",
  data: () => {
    return {
      selectItem: "",
      showSelect: false,
      mType: 0,
      diskType: 0,
      area: 1,
      diskSpace: [0, Number.POSITIVE_INFINITY],
      core: [1, 128],
      marks: {},
      tableData: [],
      tableData1: [],
      marks1: {},
      core2: [0, 3800],
      radio: 1,
      imgUrlidx: 0,
      show: false,
      selectedidx: "",
      iscolllect: false,
      list_cn2: [
        {
          name: "概述",
        },
        {
          name: "计划",
        },
      ],
      list_en2: [
        {
          name: "Overview",
        },
        {
          name: "Plan",
        },
      ],
      productData: {},
      idx: 0,
      changeid: 1,
      language: 2,
      dialogTableVisible: false,
      dialogTableVisibleinfo: false,
      basictableDate1: [],
      basictableDate: [],
      infoDesc: false,
      infoMore: false,
      isLogin: "",
      wideType: "",
    };
  },
  components: {
    navMenu: menu,
    Login: Login,
    Info: Info,
  },
  computed: {
    langIsCn: function () {
      return this.$i18n.locale == "cn";
    },
    price: function () {
      if (!this.productData.marketPricingCN) return;
      return toThousandths(`${this.productData.marketPricingCN}`)
    }
  },
  created: function () {
    var planId = this.$route.params.planId;
    var productUnionId = this.$route.params.productUnionId;
    const flightCodes = this.$route.query.flightCodes;
    this.getProductDetail(productUnionId, { flightCodes, planId });
  },
  mounted: function () {
    this.timer = setTimeout(() => {
      this.isLogin = localStorage.loginInfo;
    }, 100);
  },
  methods: {
    reportVisitor() {
      this.$store.dispatch('reportVisitor', { productIdentity: this.productData.productIdentity, recordType: 2 })
    },
    aggreSmart(data) {
      window.open(data.aggreSmartUrl);
    },
    toggle(productIdentity, collectStatus) {
      this.productData.collectStatus = !collectStatus;
      this.$store.dispatch('collectProdcut', { productIdentity, likeStatus: !collectStatus }).then(() => {
        this.productData.collectStatus = !collectStatus
      }).catch(() => {
        this.productData.collectStatus = collectStatus
      })
    },
    showDesc() {
      this.infoDesc = !this.infoDesc;
    },
    showMore() {
      this.infoMore = !this.infoMore;
    },

    toProducts() {
      this.$router.go(-1);
    },
    toProductList(data) {
      this.$store.commit("handleChange", data.categoryId); //store/index.js
      this.$store.commit("languageChange", this.language);
      this.$store.dispatch("getHotProductList");
      this.$store.commit("changePage", 1);
      this.$router.push({
        name: "ProductSPage",
        params: {
          cname: data.categoryId,
        },
      });
    },
    showWideImg(type, index) {
      if (type == 2) {
        this.imgUrlidx = index;
        this.wideType = 2;
      } else if (type == 1) {
        this.imgUrlidx = index;
        this.wideType = 1;
      }
    },
    imgPreview() {
      this.show = true;
    },
    close() {
      this.show = false;
    },
    deploy() {
      if (localStorage.loginInfo) {
        var that = this;

        var data = {
          ...that.productData,
          name: that.productData.productName,
          company: that.productData.publisherDisplayName,
          path: "/marketplace/apps/detail",
          imgUrl: that.productData.largeIcon,
          paramsData: {
            id: that.productData.id,
          },
          type: that.productData.type,
          createUrl: that.productData.createAppUrl,
          offerSummary: that.productData.offerSummary,
          legalTermsUri: that.productData.legal.legalTermsUri,
          privacyPolicyUri: that.productData.legal.privacyPolicyUri
        };
        this.$store.commit("getThisData", data);
        this.$store.commit("showPermit", true);
      } else {
        this.dialogTableVisible = true;
        this.$emit("getData", "");
      }
    },
    contact(id, productName) {
      this.dialogTableVisibleinfo = true;
      this.$store.commit("setBrickId", id);
      this.$store.commit("setBrickName", productName);
    },
    handleClick: function (idx) {
      this.idx = idx;
    },
    getProductDetail: function (id, { flightCodes, planId }) {
      this.$http
        .get(this.$api.GETPRODUCTDETAIL, {
          params: {
            productUnionId: id,
            flightCodes,
            planId,
            language: this.$store.state.language,
          }
        })
        .then((res) => {
          if (res.data.code == 200) {
            var data = JSON.stringify(res.data.data);
            sessionStorage.setItem("data", data);
            this.productData = res.data.data;
            if (this.productData.screenShotList) {
              if (this.productData.screenShotList.length > 0) {
                this.wideType = this.productData.screenShotList[0].type;
              }
            }

            this.basictableDate1 = this.productData.allSkus;
            this.tableData1 = this.productData.allSkus;
            this.reportVisitor()
          } else {
            alert(res.data.errorMessage);
            this.Router.push({ name: "error-500" });
          }
        })
        .catch((err) => {
          alert(err);
          this.Router.push({ name: "error-500" });
        });
    },
  }
};
</script>

<style lang="scss" scoped src="../../assets/css/Detail.scss"></style>
